import React from 'react';
import PropTypes from 'prop-types';
import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import { Box, Label } from 'roo-ui/components';

const StyledLabel = styled(Label)`
  font-size: ${themeGet('fontSizes.base')};
  color: ${themeGet('colors.greys.steel')};
`;

const FieldLabel = ({ htmlFor, children, mb, ...rest }) => (
  <Box {...rest}>
    <StyledLabel htmlFor={htmlFor} mb={mb}>
      {children}
    </StyledLabel>
  </Box>
);

FieldLabel.propTypes = {
  ...Box.propTypes,
  children: PropTypes.node.isRequired,
  htmlFor: PropTypes.string.isRequired,
};

export default FieldLabel;
